"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The Table component
 */
var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table() {
    _classCallCheck(this, Table);

    return _super.apply(this, arguments);
  }

  _createClass(Table, [{
    key: "renderHeaders",
    value: function renderHeaders() {
      var columns = this.props.columns;
      var headers = columns.map(function (col) {
        return /*#__PURE__*/_react.default.createElement("th", {
          scope: "col",
          key: col.id
        }, col.header);
      });
      return /*#__PURE__*/_react.default.createElement("tr", null, headers);
    }
  }, {
    key: "renderRowCells",
    value: function renderRowCells(row) {
      var _this$props = this.props,
          columns = _this$props.columns,
          callbackOnRowClick = _this$props.callbackOnRowClick;
      return columns.map(function (col) {
        var cellValue;

        if (typeof col.dataMapping === 'function') {
          cellValue = col.dataMapping(row);
        } else {
          cellValue = row[col.dataMapping];
        }

        var cellValueProps = callbackOnRowClick ? {
          onClick: callbackOnRowClick
        } : {};

        if (cellValue && _typeof(cellValue) === 'object') {
          cellValueProps.children = cellValue;
        } else if (typeof cellValue === 'string') {
          cellValueProps.dangerouslySetInnerHTML = {
            __html: cellValue
          };
        }

        return /*#__PURE__*/_react.default.createElement("td", _extends({
          key: col.id,
          "data-header": col.header,
          style: col.cellStyle,
          className: col.cellClassName
        }, cellValueProps));
      });
    }
  }, {
    key: "renderData",
    value: function renderData() {
      var _this = this;

      var data = this.props.data; // FIXME: don't think we can use index as a key here

      return data.map(function (row, i) {
        return /*#__PURE__*/_react.default.createElement("tr", {
          key: i
        }, _this.renderRowCells(row));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          columns = _this$props2.columns,
          totalRow = _this$props2.totalRow,
          className = _this$props2.className;
      var classes = (0, _classnames.default)('table', className, {
        'table--hide-headers': this.props.hideHeaders
      }, {
        'table--alt-headers': this.props.altHeaders
      }, {
        'table--hide-cell-borders': this.props.hideCellBorders
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-wrapper"
      }, /*#__PURE__*/_react.default.createElement("table", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement("thead", null, this.renderHeaders()), /*#__PURE__*/_react.default.createElement("tbody", null, this.renderData()), totalRow && /*#__PURE__*/_react.default.createElement("tfoot", null, /*#__PURE__*/_react.default.createElement("tr", {
        className: "table__total-row"
      }, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: columns.length - 1
      }, totalRow.label), /*#__PURE__*/_react.default.createElement("td", {
        "data-header": totalRow.label
      }, totalRow.value)))));
    }
  }]);

  return Table;
}(_react.default.Component);

Table.defaultProps = {
  className: null,
  hideHeaders: false,
  altHeaders: false,
  hideCellBorders: false,
  columns: [],
  data: [],
  totalRow: null,
  callbackOnRowClick: undefined
};
Table.propTypes = {
  className: _propTypes.default.string,
  hideHeaders: _propTypes.default.bool,
  altHeaders: _propTypes.default.bool,
  hideCellBorders: _propTypes.default.bool,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    header: _propTypes.default.node,

    /**
     * Either a key(string) or a function to compute the value e.g. (rowData) => 'yourValue'
     */
    dataMapping: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
    cellStyle: _propTypes.default.object,
    cellClassName: _propTypes.default.string
  })),

  /**
   * An array of objects containing the data for the table
   */
  data: _propTypes.default.arrayOf(_propTypes.default.object),
  totalRow: _propTypes.default.shape({
    label: _propTypes.default.node,
    value: _propTypes.default.node
  }),
  callbackOnRowClick: _propTypes.default.func
};
var _default = Table;
exports.default = _default;
//# sourceMappingURL=Table.js.map